module.exports = __webpack_public_path__ + "chatgpt-connector-bg.webp?7f7bbb0bbc98bb6e656283e4784c67bc";